
import * as types from './types';
import { JSON_STRING, HttpClient, MHTTPCL } from '../../../../services/http/http-client';
import { ProductsService } from '../../services/products.service';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import router from '../../../../router';
import { flatten } from 'ramda';
import { EOL_REACHED, LoadedEnd } from '../../../../dt-plugins/advanced-search/load.model';
import { type } from 'ramda';
import { dtTaskService } from '../../../../dt-plugins/dt-task/dt-task-service';

// Action Object for ProductsCatalog. Import the types from products/types.js and Invoke Actions from the Vuex Host Components.

const NavTabModule = getNavTabModule(types.ProductDetails, 'productDetails');


export const productsCatalogActions = {
  async [types.ProductsCatalogData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const productsCatalogData = await HttpClient.mergeRequests([
      ProductsService.costGeneralData(),
    ]);
    // console.log({ "productsCatalogData": productsCatalogData });
    commit(types.ProductsCatalogData.SET.ALL, productsCatalogData);
  },
  async [types.ProductList.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const { start, row_count, searchType, barCodeCatalogError, str, digital_physical, searchMode } = payload;
    console.log({ "payload": payload });

    if (searchType != 'none') {
      if (start == 0) {
        const productData = await ProductsService.fetchProductListFilter(payload);
        // console.log(productData.data.products);
        commit(types.ProductList.SET.ALL, {
          ...getters.productList,
          products: productData.data.products,
        });
      } else {
        const productListRes = await ProductsService.fetchProductListFilter(payload);

        // console.log(productListRes.data.products);

        if (productListRes.data?.products?.length > 0) {
          commit(types.ProductList.SET.ALL, {
            ...getters.productList,
            products: [
              ...getters?.productList?.products ?? [],
              ...productListRes.data?.products ?? []
            ]
          });
        } 
        
        else {
          return EOL_REACHED;
        }
      }
    } 
    else if ((str && str.length > 0) || barCodeCatalogError == true || digital_physical == 'digital' || digital_physical == 'physical') {
      const serviceArguments = {
        ...payload,
        barcode_catalog_error: barCodeCatalogError,
      };
      console.log({ "serviceArguments": serviceArguments });
      if (start == 0) {
        const productListRes = await ProductsService.searchProductList(serviceArguments);
        commit(types.ProductList.SET.ALL, productListRes.data);
      } else {
        const productListRes = await ProductsService.searchProductList(serviceArguments);

        if (productListRes.data?.products?.length > 0) {
          commit(types.ProductList.SET.ALL, {
            ...getters.productList,
            products: [
              ...getters?.productList?.products ?? [],
              ...productListRes.data?.products ?? []
            ]
          });
        } else {
          return EOL_REACHED;
        }
      }
    } else {

      console.log("SEARCH STRING EMPTY", payload, start)
      if (start == 0) {

        const productListData = await HttpClient.mergeRequests([
          ProductsService.fetchProductList()
        ]);
        commit(types.ProductList.SET.ALL, productListData);
      } else {

        const productListRes = await ProductsService.fetchProductListPage({
          startrow: start,
          row_count,
        });

        if (productListRes.data?.products?.length > 0) {
          commit(types.ProductList.SET.ALL, {
            ...getters.productList,
            products: [
              ...getters?.productList?.products ?? [],
              ...productListRes.data?.products ?? []
            ]
          });
        } else {
          return EOL_REACHED;
        }
      }
    }
  },
  async [types.ProductList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { name, item, value, colorPropertyValue, colorPropertyName } = payload;
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { product_id } = item;
    if (colorPropertyValue && colorPropertyName) {
      commit(types.ProductList.SET.ALL, {
        ...getters.productList,
        products: getters.productList.products.map(e => {
          if (e.product_id == product_id) {
            return {
              ...e,
              [name]: value,
              [colorPropertyName]: [colorPropertyValue]
            };
          } else {
            return e;
          }
        })
      });

      if (getters.productDetails && getters.productDetails != null && getters.productDetails[product_id] != undefined) {
        NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
          console.log(productObj);
          return {
            product: {
              ...productObj.product,
              [name]: value,
              [colorPropertyName]: [colorPropertyValue]
            }
          }
        });
      }

      const productListData = await HttpClient.modifyJSON(
        undefined,
        product_id,
        colorPropertyName,
        colorPropertyValue,
        'l_products',
      );

    }
    commit(types.ProductList.SET.ALL, {
      ...getters.productList,
      products: getters.productList.products.map(e => {
        if (e.product_id == product_id) {
          return {
            ...e,
            [name]: value
          };
        } else {
          return e;
        }
      })
    });

    const productListData = await HttpClient.modifyJSON(
      undefined,
      product_id,
      name,
      value,
      'l_products',
    );

    console.log(productListData);
  },

  async [types.ProductList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { product_id } = payload;

    commit(types.ProductList.SET.ALL, {
      ...getters.productList,
      products: getters.productList.products.filter(e => e.product_id !== product_id)
    });

    await ProductsService.removeProduct(product_id);



    // const productListData = await HttpClient.modifyJSON(
    //   undefined,
    //   product_id,
    //   name,
    //   value,
    //   'l_products',
    // );


  },


  async [types.ProductDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    let { flag, product, reload } = payload;

    console.log("ProductDetails.FETCH.SINGLE", payload);

    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'product_id';
    const itemName = 'product';
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'productDetails';
    const DetailsAction = types.ProductDetails;


    // Check Reload and prexisting Item Logic

    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true,
      }
    })

    // HTTP Req

    const detailsResponse = await HttpClient.mergeRequests([
      ProductsService.fetchProductDetails(product.product_id),
      ProductsService.fetchProductDetailsTabText(product.product_id),
      ProductsService.fetchProductOverviewTab(product.product_id),
      ProductsService.fetchProductRelease(product.product_id),
      ProductsService.fetchProductTracks(product.product_id),
      ProductsService.getContracts(product.product_id),
      ProductsService.fetchProductSales(product.product_id),
      ProductsService.productDetailsTabStock(product.product_id),
      ProductsService.specialsData(product.product_id),
      ProductsService.productDetailsTabMetadata(product.product_id),
      ProductsService.showMetadata(product.product_id),
      ProductsService.costTab(product.product_id),
      ProductsService.otherIncomeTab(product.product_id),
      ProductsService.getProductRelatedSupplierOrderlines(product.product_id),
      dtTaskService.taskList(product.product_id,'product')

    ]);

    const resReleaseData = await ProductsService.costReleaseTab(detailsResponse.product.release_id);
    const release_income_product_costs_total = resReleaseData.data.product_costs_total
    console.log("detailsResponse", detailsResponse);
    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, product) => {
      return {
        ...product,
        ...detailsResponse,
        release_income_product_costs_total: release_income_product_costs_total,
        loading: false,
      }
    })
  },
  ...NavTabModule.implementActions(
    'product_id',
    'products/product_id/tab',
    'products',
    () => router,
    'catalog',
    (value, key) => {
      const { product, product_release } = value;
      const { release_title, release_artist } = product_release || product || {};

      return {
        title: product?.catalog_no ? `${product?.catalog_no} ${release_title || ''}` : key,
        full_title: `${product?.catalog_no} ${release_title || ''} ${release_artist || ''}`,
      }
    }
  ),

  // Action of Updating single Object
  async [types.ProductDetails.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item } = payload;
    const { product } = item;
    const { product_id } = product;

    const productObj = getters.productDetails[product_id];

    // console.log({ productOB: productObj });
    let stockInfo = 0;
    if (name == 'stock_location_id') {
      const resStockInfo = await ProductsService.productStockLocationInfo(product_id)
      stockInfo = resStockInfo.data.stock_qty_on_stock_location
      console.log(resStockInfo, ":::::::::::::");
    }

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      console.log(productObj);
      return {
        product: {
          ...productObj.product,
          [name]: value,
          stock_qty_on_stock_location: stockInfo
        }
      }
    });

    const table = 'l_products';

    const updatedProductDetailsRes = await MHTTPCL.modifyJSON(
      undefined,
      product_id,
      name,
      value,
      table,
    );

    // console.log(updatedProductDetailsRes.data);
  },
  async [types.UPDATE_PRODUCT_DETAILS_STATE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { product_costs_total, product_id } = payload;
    console.log({ "payload": payload });

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      return {
        product_costs_total: +product_costs_total,
      }
    });
  },
  async [types.PriceList.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item, product } = payload;
    const { product_id } = product;

    const productObj = getters.productDetails[product_id];

    // console.log({ productOB: productObj });

    const key = 'product_price_id';
    const kVal = item[key];
    const table = 'l_product_prices';

    const oldValue = item[name];
    if (oldValue == value) {
      return;
    }

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      return {
        pricelists: productObj.pricelists.map(price => {
          if (price.product_price_id == item.product_price_id) {
            return {
              ...price,
              [name]: value,
            };
          } else {
            return price;
          }
        })
      }
    });

    const updatedPriceRes = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table,
    );

    // console.log(updatedProductDetailsRes.data);
  },

  async [types.ProductGroups.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { group, item } = payload;
    const { product_id } = item
    const { relation_id } = group;

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        groups: productObj.groups.
          filter(e => e.relation_id != relation_id)
      }
    });

    const deletedContact = await ProductsService.removeProductGroup(relation_id)


  },

  async [types.ProductGroups.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { action, groups, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    // const newRelatedProduct=await releaseService.newRelatedReleaseProduct(catalog_no,format_id,related_product_id,release_id)
    //const relatedProductList=await releaseService.loadReleaseRelatedProducts(release_id);
    const groupLIST = await ProductsService.addGroups(action, product_id, groups)
    console.log("Log: newRelatedLink", groupLIST);




    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        groups: groupLIST.data.groups
      };
    })


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });

  },

  async [types.ProductAccounts.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { product_id } = payload

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    // const newRelatedProduct=await releaseService.newRelatedReleaseProduct(catalog_no,format_id,related_product_id,release_id)
    //const relatedProductList=await releaseService.loadReleaseRelatedProducts(release_id);
    const accountLIST = await ProductsService.getAccounts(product_id);
    console.log("Log: newRelatedLink", accountLIST);




    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        accounts: accountLIST.data.accounts
      };
    })


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });

  },

  async [types.ProductAccounts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)

    const { product_account_id, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        accounts: productObj.accounts.
          filter(e => e.product_account_id != product_account_id)
      }
    });

    const deletedAccount = await ProductsService.deleteProductAccount(product_account_id);


  },

  async [types.ProductAccounts.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { accounts, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    // const newRelatedProduct=await releaseService.newRelatedReleaseProduct(catalog_no,format_id,related_product_id,release_id)
    //const relatedProductList=await releaseService.loadReleaseRelatedProducts(release_id);
    const groupLIST = await ProductsService.productAddAccount(product_id, accounts);
    console.log("Log: newRelatedLink", groupLIST);




    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        accounts: groupLIST.data.accounts
      };
    })


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });

  },

  async [types.ProductTracks.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)

    const { product_track_id, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        tracks: productObj.tracks.
          filter(e => e.product_track_id != product_track_id)
      }
    });

    const deletedTrack = await ProductsService.deleteProductTrack(product_track_id);


  },

  async [types.ProductMedia.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)

    const { product_media_id, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        product_medias: productObj.product_medias.
          filter(e => e.product_media_id != product_media_id)
      }
    });

    const deletedTrack = await ProductsService.removeProductMedia(product_media_id);


  },

  async [types.ProductMedia.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { mechanical_reg_no, media_id, set_no, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    // const newRelatedProduct=await releaseService.newRelatedReleaseProduct(catalog_no,format_id,related_product_id,release_id)
    //const relatedProductList=await releaseService.loadReleaseRelatedProducts(release_id);
    const mediaLIST = await ProductsService.newProductMedia(product_id, set_no, mechanical_reg_no, media_id);
    console.log("Log: newRelatedLink", mediaLIST);




    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        product_medias: mediaLIST.data.product_medias
      };
    })


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });

  },


  async [types.ProductMedia.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)
    console.log("PPPPPP", payload);
    const { mechanical_reg_no, media_id, set_no, item, kVal, media_name } = payload;
    const { product_id } = item
    //const productObj = getters.productDetails[product_id];

    // console.log({ productOB: productObj });

    //const key = 'product_price_id';
    //const kVal = item[key];
    const table = 'l_product_media';
    const modify_type = 'record';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      return {
        product_medias: productObj.product_medias.map(e => {
          if (e.product_media_id == kVal) {
            return {
              ...e,
              mechanical_reg_no: mechanical_reg_no,
              media_id: media_id,
              set_no: set_no,
              media_name: media_name
            };
          } else {
            return e;
          }
        })
      }
    });

    console.log("METADATA")
    const updatedPriceRes = ProductsService.modifyGema(kVal, set_no, media_id, mechanical_reg_no);

    // console.log(updatedProductDetailsRes.data);
  },

  async [types.PriceList.SET.ALL]({ commit, getters, dispatch }, arg) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", arg)
    const { payload, item } = arg;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    // const newRelatedProduct=await releaseService.newRelatedReleaseProduct(catalog_no,format_id,related_product_id,release_id)
    //const relatedProductList=await releaseService.loadReleaseRelatedProducts(release_id);
    let priceLIST;
    if (payload == "reset_prices_from_price_code") {
      priceLIST = await ProductsService.resetPrices(product_id);
    }
    else {
      priceLIST = await ProductsService.addProductPrices(product_id);
    }

    console.log("Log: newRelatedLink", priceLIST);




    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        pricelists: priceLIST.data.pricelists
      };
    })


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });

  },

  async [types.PriceList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)

    const { product_price_id, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        pricelists: productObj.pricelists.
          filter(e => e.product_price_id != product_price_id)
      }
    });

    const deletedTrack = await ProductsService.deleteProductPrice(product_price_id);


  },

  async [types.ProductManufacture.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { external_id, supplier_id, supplier_order_date, supply_order_type } = payload;
    const product_id = external_id

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    // const newRelatedProduct=await releaseService.newRelatedReleaseProduct(catalog_no,format_id,related_product_id,release_id)
    //const relatedProductList=await releaseService.loadReleaseRelatedProducts(release_id);
    const mediaLIST = await ProductsService.addManufacturingOrder(external_id, supplier_id, supply_order_type, supplier_order_date);
    console.log("Log: newRelatedLink", mediaLIST);




    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        manufacturing_orders: mediaLIST.data.manufacturing_orders
      };
    })


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });

    return mediaLIST.data.manufacturing_orders

  },

  async [types.BackOrder.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)

    const { backorder_id, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        backorders: productObj.backorders.
          filter(e => e.backorder_id != backorder_id)
      }
    });

    const deletedTrack = await ProductsService.deleteBackorder(product_id, backorder_id);


  },

  async [types.BackOrder.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { external_id, account_id, qty } = payload;
    const product_id = external_id

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    // const newRelatedProduct=await releaseService.newRelatedReleaseProduct(catalog_no,format_id,related_product_id,release_id)
    //const relatedProductList=await releaseService.loadReleaseRelatedProducts(release_id);
    const mediaLIST = await ProductsService.addProductAccountBackorder(product_id, account_id, qty);
    console.log("Log: newRelatedLink", mediaLIST);




    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        backorders: mediaLIST.data.backorders
      };
    })


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });

  },

  async [types.ProductManualMatches.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log(":::", payload)
    const { item, product } = payload;
    const { product_id } = product;

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });

    const newMatchedAccount = await ProductsService.addProductAccountRelation(product_id, item.account_id, item.text02)


    console.log("Log: newRelatedLink", newMatchedAccount);

    console.log("Log: newRelatedLink", newMatchedAccount);

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        match_accounts: newMatchedAccount.data.match_accounts
      };
    })

    // } else {
    //   await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    // }
    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });
  },

  async [types.ProductManualMatches.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { relation_id, item } = payload;
    const { product_id } = item;


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        match_accounts: productObj.match_accounts.
          filter(e => e.relation_id != relation_id)
      }
    })

    const deletedLinks = await ProductsService.removeManualMatch(relation_id);
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.CountryRestricted.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { country_relation_id, item } = payload;
    const { product_id } = item;

    const resData = await ProductsService.removeCountryRelation(country_relation_id);
    console.log(":::RESDATA", resData)

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        countries: productObj.countries.filter(e => e.country_relation_id != country_relation_id),
        countries_allowed: resData.data.countries_allowed
      }
    })


    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },
  async [types.CountryRestricted.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { product_id } = payload;
    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    })
    const resData = await ProductsService.invertCountries(product_id)
    console.log(":::RESDATA", resData)

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
        countries: resData.data.countries,
        countries_allowed: resData.data.countries_allowed
      }
    })


    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },


  async [types.CountryRestricted.DELETE.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { product_id } = payload;

    const resData = await ProductsService.removeCountries(product_id);
    console.log(":::RESDATA", resData)

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        countries: resData.data.countries,
        countries_allowed: resData.data.countries_allowed
      }
    })


    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.CountryRestricted.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { product_id, territory_id, country_id, name } = payload;
    let countries = [];
    let countries_allowed = [];
    if (name == "country") {
      const resData = await ProductsService.addCountry(product_id, country_id);
      countries = resData.data.countries;
      countries_allowed = resData.data.countries_allowed
    }
    else if (name == "territory") {
      const resData = await ProductsService.addTerritory(product_id, territory_id);
      console.log(":::RESDATA", resData)
      countries = resData.data.countries;
      countries_allowed = resData.data.countries_allowed
    }

    // console.log(":::RESDATA",resData)

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        countries: countries,
        countries_allowed: countries_allowed
      }
    })


    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.ProductMetaData.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item, kVal } = payload;
    const { product_id } = item
    //const productObj = getters.productDetails[product_id];

    // console.log({ productOB: productObj });

    //const key = 'product_price_id';
    //const kVal = item[key];
    const table = 'metadata';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      return {
        all_item_metadata: productObj.all_item_metadata.map(e => {
          if (e.metadata_id == kVal) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    console.log("METADATA")
    const updatedPriceRes = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table,
    );

    // console.log(updatedProductDetailsRes.data);
  },

  async [types.Royalty.UPDATE.MULTIPLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    //const { name, value, item, kVal } = payload;
    const { product_id } = payload


    const contract = await ProductsService.updateReleaseContracts(product_id);

    const updatedContracts = await ProductsService.getContracts(product_id);

    console.log(updatedContracts)

    // const key = 'contract_pos_id';
    // //const kVal = item[key];
    // const table = 'l_contract_pos';



    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      return {
        contract: updatedContracts.data.contract
      }
    });

    console.log("METADATA")
  },

  async [types.Royalty.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item, kVal } = payload;
    const { product_id } = item
    //const productObj = getters.productDetails[product_id];

    // console.log({ productOB: productObj });

    const key = 'contract_pos_id';
    //const kVal = item[key];
    const table = 'l_contract_pos';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      return {
        pricelists: productObj.contract.map(e => {
          if (e.contract_pos_id == kVal) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    console.log("METADATA")
    const updatedPriceRes = await MHTTPCL.modifyJSON(
      key,
      kVal,
      name,
      value,
      table,
    );

    // console.log(updatedProductDetailsRes.data);
  },

  async [types.OpenOrder.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)

    const { orderline_id, item } = payload;
    const { product_id } = item

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {

        open_orders: productObj.open_orders.
          filter(e => e.orderline_id != orderline_id)
      }
    });

    const deletedTrack = await ProductsService.deleteOrderline(orderline_id, product_id);


  },

  async [types.Stocks.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)
    console.log(payload)
    const { stock_qty, account_id, adjusted_stock, notes, date, product_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      return {
        accounts_stock: productObj.accounts_stock.map(e => {
          if (e.account_id == account_id) {
            return {
              ...e,
              product_stock: adjusted_stock,
            };
          } else {
            return e;
          }
        })
      }
    });

    console.log("METADATA")
    const updatedPriceRes = await ProductsService.adjustStock(product_id, stock_qty, account_id, adjusted_stock, notes, date);

    // console.log(updatedProductDetailsRes.data);
  },

  async [types.SET_CATALOG_PRODUCT_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    NavTabHelper.setSingleNavTabDetails(externalId, (_, productDetails) => {
      console.log(externalId, productDetails);
      return {
        ...productDetails,
        files: files,
      }
    });
  },

  async [types.TrackList.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const {
      product_id,
      name,
      track_list,
      title,
      version,
      artist,
      playtime,
      isrc,
      digital_right_type,
      track_id
    } = payload;


    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    // const newRelatedProduct=await releaseService.newRelatedReleaseProduct(catalog_no,format_id,related_product_id,release_id)
    //const relatedProductList=await releaseService.loadReleaseRelatedProducts(release_id);
    let trackList = {}
    if (name == "new") {
      trackList = await ProductsService.productNewTrack(product_id, title, artist, playtime, isrc, version, digital_right_type);


    }
    else if (name == "existing") {
      trackList = await ProductsService.addSelectedTracks(product_id, track_list);
    }
    else {
      await ProductsService.duplicateTrack(track_id, product_id, artist, title, version, playtime);
      trackList = await ProductsService.fetchProductTracks(product_id);
    }

    console.log("Log: newRelatedLink", trackList);
    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        tracks: trackList.data.tracks
      };

    })
    //const groupLIST = await ProductsService.addGroups(product_id, groups)








    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: false,
      }
    });

  },

  async [types.OnlyTracks.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { product_id } = payload;
    const res = await ProductsService.fetchProductTracks(product_id);
    console.log("::::::RES::::::", res, product_id)
    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      console.log(productObj);
      return {
        only_tracks: res.data.only_tracks
      }
    });
  },

  async [types.TrackList.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item, product_id } = payload;
    const { product_track_id, track_id } = item;


    //const productObj = getters.productDetails[product_id];

    console.log('{ productOB: productObj }', name, item);

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      console.log(productObj);
      return {
        tracks: productObj.tracks.map(e => {
          if (e.product_track_id == product_track_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    if (name == 'seq_no') {
      NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
        console.log(productObj);
        return {
          only_tracks: productObj.only_tracks.map(e => {
            if (e.track_id == track_id) {
              return {
                ...e,
                [name]: value,
              };
            } else {
              return e;
            }
          })
        }
      });
    }

    const table = 'l_product_tracks';

    const updatedProductDetailsRes = await MHTTPCL.modifyJSON(
      undefined,
      product_track_id,
      name,
      value,
      table,
    );

    // console.log(updatedProductDetailsRes.data);
  },

  async [types.OnlyTracks.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, kVal, item } = payload;
    const { product_id } = item;


    //const productObj = getters.productDetails[product_id];

    console.log(name, value, kVal, "{:::::::::::::}");

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      console.log(productObj);
      return {
        only_tracks: productObj.only_tracks.map(e => {
          if (e.track_id == kVal) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    const table = 'l_tracks';

    const updatedProductDetailsRes = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table,
    );

    // console.log(updatedProductDetailsRes.data);
  },


  async [types.UPDATE_PLAYTIME]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { action, product_id } = payload;
    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });


    await ProductsService.updatePlayTime(action, product_id);
    const trackList = await ProductsService.productTracksHtml(product_id);

    console.log("trackList::::", trackList);

    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        tracks: trackList.data.tracks,
        loading: false
      };

    });
  },
  async [types.SET_STOCK_RELOCATION]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const {product_id } = payload;
    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        loading: true,
      }
    });
    const stockData = await ProductsService.productDetailsTabStock(product_id);
    console.log("stockData::::", stockData);
    NavTabHelper.updateSingleNavTabDetails(product_id, productObj => {
      return {
        accounts_stock: stockData.data.accounts_stock,
        loading: false
      };

    })



  },
  async [types.SET_COPY_TRACK]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { main_product_id, product_id } = payload;
    NavTabHelper.updateSingleNavTabDetails(main_product_id, productObj => {
      return {
        loading: true,
      }
    });
    const trackList = await ProductsService.copyTrackFromCatalog(main_product_id, product_id);
    console.log("trackList::::", trackList);
    NavTabHelper.updateSingleNavTabDetails(main_product_id, productObj => {
      return {
        tracks: trackList.data.tracks,
        loading: false
      };

    })



  },

  async [types.SET_CATALOG_PRODUCT_ARTWORK]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { selectedProductDetails, file, artworkKey } = payload;
    console.log({'actions.js:1347 payload' : payload});
    const { file_id } = file ? file : { file_id: '' };
    const { product } = selectedProductDetails;
    const { product_id } = product;


    NavTabHelper.updateSingleNavTabDetails(product_id, (_) => {
      return {
        [artworkKey]: file ? file.file_link : '',
      }
    });

    const serverName = {
      artwork1: 'artwork_product1',
      artwork2: 'artwork_product2'
    }[artworkKey];

    await MHTTPCL.modify(
      'product_id',
      product_id,
      serverName,
      file_id,
      'l_products'
    );
  },


  async [types.HarryFox.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, excess_mechanical_rate, product_id } = payload;


    const productObj = getters.productDetails[product_id];

    // console.log({ productOB: productObj });

    NavTabHelper.updateSingleNavTabDetails(product_id, (productObj) => {
      console.log(productObj);
      return {
        product: {
          ...productObj.product,
          [name]: excess_mechanical_rate,
        }
      }
    });


    await ProductsService.saveExcessMechanicalRate(product_id, excess_mechanical_rate);

    // console.log(updatedProductDetailsRes.data);
  },
}
